(function (Drupal, $) {
  Drupal.behaviors.card_view_listing = {
    attach: function (context) {
      $(function() {
        
        $('.card-view-listing').each(function() {
          $(this).closest('.card-view-listing__wrapper').show();
          var intro = $(this).find('.card-view-listing__intro >p:first-of-type');
          let isResource = $(this).closest('.card-resources');
          let isNews = $(this).parents('.view-news').length >= 1;
          var intro_height = intro.height();
          
          if (isNews) {
            // Character-based truncation for news cards (160 characters)
            let text = intro.text();
            if (text.length > 160) {
              intro.text(text.substring(0, 160) + "...");
            }
          } else {
            // Height-based truncation for other cards
            let lin4Crop = isResource.length >= 1 ? 260 : 100;
            let lin2Crop = isResource.length >= 1 ? 150 : 50;
            
            if($(window).width() < 1024) {
              while (intro_height > lin4Crop) { // 4 lines crop
                intro.text(intro.text().split("").slice(0, -3).join("") + "…");
                intro_height = intro.parent().height();
              }
            } else {
              while (intro_height > lin2Crop) { // 2 lines crop
                intro.text(intro.text().split("").slice(0, -3).join("") + "…");
                intro_height = intro.parent().height();
              }
            }
          }
        });

        $('.card-view-listing__wrapper').each(function(index) {
          var $this = $(this);

          if($this.hasClass('search-result-card')) {
            var title = $this.find('.card-view-listing__title >a').text();
            var url = $this.find('.card-view-listing__title >a').attr('href');
            $this.find('.card-view-listing__title >a').remove();
            $this.find('.card-view-listing__title').text(title);
            $this.children('.card-view-listing').wrapInner("<a href='"+url+"'></a>")
          }

          setTimeout(function() {
            $this.css({
              'opacity': '1',
              'visibility': 'visible',
              'transform': 'translateX(0)'
            });
          }, 125*index);
        });

      });      
    }
  }
})(Drupal, jQuery);